export enum CashbackType {
    None,
    Customizado,
    Padronizado,
    CustomizadoPadronizado
}
